import React, { useMemo } from "react";
import { Avatar as AntdAvatar } from "antd";
import classNames from "classnames";
import "./styles.scss"
import errorImage from "../../assets/icons/greendark.svg"

export const Avatar = ({ icon, size = 40,  alt }) => {
  return (
    <div className="image-rounded">
      {icon?.length > 0 && typeof icon === "string" ? (
        <img
          src={icon}
          alt={`Avatar ${alt}`}
          style={icon && { backgroundColor: "transparent !important", height: size, width: size }}
          onError={(e) => {
            e.target.src = errorImage
          }}
        />
      ) : (
        <div className="avatar" style={{ backgroundColor: "#F2F2F2", height: size, width: size }}>
          <svg
            width="144"
            height="130"
            viewBox="0 0 144 144"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="71.789" cy="71.789" r="71.789" fill="#F2F2F2" />
            <mask
              id="mask0_4471_2165"
              style={{ "mask-type": "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="144"
              height="144">
              <circle cx="71.789" cy="71.789" r="71.789" fill="#F2F2F2" />
            </mask>
            <g mask="url(#mask0_4471_2165)">
              <ellipse cx="71.7889" cy="126.349" rx="54.5596" ry="31.5872" fill="#9A9"/>
            </g>
            <circle cx="71.7889" cy="61.0207" r="25.844" fill="#9A9" />
          </svg>
        </div>
      )}
    </div>
  )
}

export const AvatarIcon = ({ icon, name, size = "40", rounded = true, backgroundColor = "F2F2F2", color = "000" }) => {

  const background = backgroundColor === "random" ? "&background=random" : `&background=${backgroundColor}&color=${color}`
  const avatarLink = !icon && `https://ui-avatars.com/api/?size=${size}&rounded=${rounded}${background}&name=${name}`

  return (
    <div className={`${avatarLink ? "avatar-link" : "image-rounded"}`} title={name} style={{width: size, height: size}}>
      <img
        src={icon?.length > 0 && typeof icon === "string" ? icon : avatarLink}
        alt={`Avatar ${name}`}
        style={icon ? { backgroundColor: "transparent !important" } : {}}
        onError={(e) => {
          e.target.src = avatarLink
        }}
      />
    </div>
  )
}

const getRandomColor = (seed) => {
  const getChannel = (seed, offset, min = 80, max = 200) => {
    const base = Math.abs(Math.sin(seed + offset) * 10000) % 256;
    const range = max - min;
    return Math.floor((base * 0.6) % range + min);
  };

  // Geração de cores vibrantes, mas controlando brilho
  const red = getChannel(seed, 0, 80, 200);   // Ajustado para tons mais saturados
  const green = getChannel(seed, 100, 80, 200);
  const blue = getChannel(seed, 200, 80, 200);

  return `rgb(${red}, ${green}, ${blue})`;
};

const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash &= hash;
  }
  return Math.abs(hash);
};

export const CustomAvatar = ({ imageUrl, userName, className, size = 40 }) => {
  const getInitials = (name) => {
    return name
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase())
      .join("")
      .slice(0, 2);
  };

  const randomColor = useMemo(() => {
    const seed = userName ? hashString(userName + Math.random()) : Math.random();
    return getRandomColor(seed);
  }, [userName]);

  return imageUrl ? (
    <AntdAvatar
      src={imageUrl}
      size={size}
      className={classNames("avatar-image", className)}
      style={{
        borderRadius: "50%",
        overflow: "hidden",
      }}
    />
  ) : (
    <AntdAvatar
      size={size}
      className={classNames("avatar-initials", className)}
      style={{
        backgroundColor: randomColor,
        borderRadius: "50%",
        color: "#fff",
        fontWeight: "regular",
      }}
    >
      {getInitials(userName)}
    </AntdAvatar>
  );
};

export const CustomAvatarGroup = ({
  users,
  keyAvatarImage = null,
  keyAvatarName = "userName",
  maxCount = 1000,
  size = 32,
  className
}) => {
  const limitedUsers = users.slice(0, maxCount);
  const groupColor = "#1677ff";

  return (
    <AntdAvatar.Group
      maxCount={1000}
      className={classNames("avatar-group", className)}
      size={size}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      {limitedUsers.map((user, index) => (
        <CustomAvatar
          key={index}
          imageUrl={user[keyAvatarImage] || user?.imageUrl}
          userName={user[keyAvatarName] || user?.userName}
          size={size}
        />
      ))}
      {users?.length > 3 && users?.length <= 1000 ? (
        <AntdAvatar style={{ backgroundColor: groupColor }}>
          {users?.length > 1000 ? "1000+" : `+${users?.length - (limitedUsers?.length || 0)}`}
        </AntdAvatar>
      ) : null}
    </AntdAvatar.Group>
  );
};